import LogButton from './LogButton';

export default LogButton;
